import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { BasketService } from '../basket.service';
import { MessageService } from 'primeng/primeng';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-add-product-to-basket',
  templateUrl: './add-product-to-basket.component.html',
  styleUrls: ['./add-product-to-basket.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class AddProductToBasketComponent implements OnInit {

  @Input() readOnly: boolean = false;

  @Output() productsListSelected: EventEmitter<any> = new EventEmitter<any>();
  @Output() productsListCancel: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('productsListTable') productsListTable: Campaign3KontableComponent;

  rowSelected = { identifierField: 'id', arrayValues: [] };

  listProductsSelected: Array<any> = [];

  paginationType: number = Campaign3KontableComponent.ClientPagination;
  customFilter: number = Campaign3KontableComponent.CustomFilter;

 @Input() productsNotInSelectedBasket:any[];

  show = {
    table: false
  };



  filterModel = {
    insegna: [],
    gruppo: [],
    area: []
  };

  constructor(
    private basketService: BasketService,
    private srvMessage: MessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.show.table = true;
  }
 //TODO per ora hanno lo stesso id capire come differernziarlo
  onProductsSelected(product: any): void {
    if (this.readOnly) {
      return;
    }

    var index = this.listProductsSelected.findIndex(function (x) {
      return x.id === product.id;
    });

    if (!product.rowSelected) {
      if (index > -1) {
        this.listProductsSelected.splice(index, 1);
      }
    } else {
      if (index === -1) {
        this.listProductsSelected.push(product);
      }
    }
  }

  onClickRemoveSelected(index: number): void {
    this.listProductsSelected.splice(index, 1);
  }

  onClickAddProducts(): void {
    if (this.listProductsSelected && this.listProductsSelected.length > 0) {
      this.productsListSelected.emit(this.listProductsSelected);
    } else {
      this.productsListSelected.emit(null);
    }
  }

  onClickCancelProducts(): void {
    this.productsListCancel.emit(true);
  }

  onChangeFilters(): void {
    this.refreshTable();
  }



  refreshTable(): void {

    var filterObj = {
      area: [],
      gruppoCode: [],
      insegnaCode: []
    };

    for (var i = 0; i < this.filterModel.area.length; i++) {
      if (this.filterModel.area[i] && this.filterModel.area[i].codice) {
        filterObj.area.push(this.filterModel.area[i].codice);
      }
    }

    for (var j = 0; j < this.filterModel.gruppo.length; j++) {
      if (this.filterModel.gruppo[j] && this.filterModel.gruppo[j].code) {
        filterObj.gruppoCode.push(this.filterModel.gruppo[j].code);
      }
    }

    for (var k = 0; k < this.filterModel.insegna.length; k++) {
      if (this.filterModel.insegna[k] && this.filterModel.insegna[k].codice) {
        filterObj.insegnaCode.push(this.filterModel.insegna[k].codice);
      }
    }

  
  }
}



// WEBPACK FOOTER //
// ./src/app/views/baskets/add-product-to-basket/add-product-to-basket.component.ts